import React from 'react';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import PageTransition from '@/components/PageTransition';
import PodcastInterviewsContent from '@/app/podcast/components/PodcastInterviewsContent';

export default function PodcastInterviewsPage() {
    return (
        <main className="min-h-screen bg-background">
            <Header />
            <PageTransition>
                <PodcastInterviewsContent />
                <Footer />
            </PageTransition>
        </main>
    );
}
